import React, { PureComponent } from 'react';
import { Button, message } from 'antd';
import styles from './index.scss';

export default class Export extends PureComponent {
  state = {
    exportLoading: false,
  };

  handleExportsBefore = () => {
    const { handleExportsBefore } = this.props;
    const tableList = handleExportsBefore();
    if (tableList.length > 0) {
      this.handleExports();
    } else {
      message.error('没有查询到数据');
    }
  };

  handleExports = () => {
    const { handleExports, params } = this.props;
    this.setState({
      exportLoading: true,
    });
    handleExports(params)
      .then(res => {
        message.success('发起导出任务成功，正在加载数据，请稍等...');
      })
      .finally(value => {
        this.setState({
          exportLoading: false,
        });
      });
  };

  render() {
    const { exportLoading } = this.state;
    const { text, type, handleExportsBefore } = this.props;
    return (
      <Button
        type={type || 'primary'}
        className={styles.mr10}
        loading={exportLoading}
        onClick={handleExportsBefore ? handleExportsBefore : this.handleExports}
        {...this.props}>
        {exportLoading ? (text ? `${text}导出中...` : '导出中...') : text ? text : '导出'}
      </Button>
    );
  }
}
